import {
  AccountBalance,
  CheckCircle,
  CopyAll,
  Lightbulb,
  Receipt,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Divider,
  Fade,
  Grid,
  Paper,
  Typography,
  Zoom,
} from '@mui/material';
import { sahinAlertDialog } from '@sahinyazilim/sahinyazilim-components';
import { currencyFormat } from 'common/utils/helper';
import { OwnerEnv } from 'common/utils/env';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const PaymentSuccess: React.FC = () => {
  const { state } = useLocation();
  const [showContent, setShowContent] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 3,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // State'den gelen bilgileri al
  const plan = state?.plan || {};
  // const buyer = state?.buyer || {};
  const bank = {
    iban: OwnerEnv.bank.iban,
    name: OwnerEnv.bank.name,
    owner: OwnerEnv.bank.accountHolder,
    description: 'Ödeme Referans: ',
  };
  const paymentReference = state?.paymentId; // Bu değer backend'den gelecek

  useEffect(() => {
    // Sadece giriş animasyonu
    const timer = setTimeout(() => setShowContent(true), 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // 3 günlük geri sayım
    const endTime = new Date().getTime() + 3 * 24 * 60 * 60 * 1000; // 3 gün

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance > 0) {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleCopyBankInfo = (text: string) => {
    navigator.clipboard.writeText(text);
    sahinAlertDialog({
      message: 'IBAN kopyalandı',
      type: 'success',
    });
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        boxSizing: 'border-box',
        overflow: 'auto',
        backgroundColor: 'background.default',
      }}
    >
      <Fade in={showContent} timeout={800}>
        <Paper
          elevation={8}
          sx={{
            p: 2,
            borderRadius: 3,
            width: '100%',
            maxWidth: 800,
            textAlign: 'center',
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          {/* Başarı İkonu */}
          <Zoom in={showContent} timeout={600}>
            <Box sx={{}}>
              <CheckCircle
                sx={{
                  fontSize: 64,
                  color: 'success.main',
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                }}
              />
            </Box>
          </Zoom>

          {/* Başlık */}
          <Fade in={showContent} timeout={1000}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: 'text.primary',
              }}
            >
              Ödeme Talebi Alındı
            </Typography>
          </Fade>

          {/* Ana Açıklama */}
          <Fade in={showContent} timeout={1200}>
            <Typography
              variant="h6"
              sx={{
                mb: 1,
                color: 'success.main',
                fontWeight: 500,
              }}
            >
              🎉 Hesabınız şu anda aktif!
            </Typography>
          </Fade>

          <Fade in={showContent} timeout={1300}>
            <Typography
              variant="body1"
              sx={{
                mb: 2,
                color: 'text.secondary',
                lineHeight: 1.7,
                fontSize: '1.1rem',
              }}
            >
              Ödeme talebiniz başarıyla oluşturuldu. Lütfen aşağıdaki banka
              hesabına ödemenizi yapın.
            </Typography>
          </Fade>

          {/* Geri Sayım Sayaç */}
          <Fade in={showContent} timeout={1400}>
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="h6"
                sx={{
                  color: 'text.primary',
                  fontWeight: 600,
                  mb: 1.5,
                  textAlign: 'center',
                }}
              >
                Ödeme Süreniz
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 1.5,
                  mb: 1.5,
                }}
              >
                {/* Gün */}
                <Box
                  sx={{
                    textAlign: 'center',
                    p: 1.5,
                    borderRadius: 2,
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: 'text.primary',
                    minWidth: 60,
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700, color: 'text.primary' }}
                  >
                    {timeLeft.days}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: '0.7rem', color: 'text.secondary' }}
                  >
                    GÜN
                  </Typography>
                </Box>

                {/* Saat */}
                <Box
                  sx={{
                    textAlign: 'center',
                    p: 1.5,
                    borderRadius: 2,
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: 'text.primary',
                    minWidth: 60,
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700, color: 'text.primary' }}
                  >
                    {timeLeft.hours.toString().padStart(2, '0')}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: '0.7rem', color: 'text.secondary' }}
                  >
                    SAAT
                  </Typography>
                </Box>

                {/* Dakika */}
                <Box
                  sx={{
                    textAlign: 'center',
                    p: 1.5,
                    borderRadius: 2,
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: 'text.primary',
                    minWidth: 60,
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700, color: 'text.primary' }}
                  >
                    {timeLeft.minutes.toString().padStart(2, '0')}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: '0.7rem', color: 'text.secondary' }}
                  >
                    DAKİKA
                  </Typography>
                </Box>

                {/* Saniye */}
                <Box
                  sx={{
                    textAlign: 'center',
                    p: 1.5,
                    borderRadius: 2,
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: 'text.primary',
                    minWidth: 60,
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700, color: 'text.primary' }}
                  >
                    {timeLeft.seconds.toString().padStart(2, '0')}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: '0.7rem', color: 'text.secondary' }}
                  >
                    SANİYE
                  </Typography>
                </Box>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  textAlign: 'center',
                  fontWeight: 500,
                }}
              >
                Bu süre içinde ödemenizi tamamlayarak kalıcı erişim
                sağlayabilirsiniz
              </Typography>
            </Box>
          </Fade>

          {/* Banka Hesap Bilgileri ve Ödeme Detayları */}
          <Fade in={showContent} timeout={1500}>
            <Box sx={{ mb: 4 }}>
              <Grid container spacing={3}>
                {/* Banka Hesap Bilgileri */}
                <Grid item xs={12} md={8}>
                  <Box
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: 'action.hover',
                      border: '1px solid',
                      borderColor: 'divider',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2,
                        gap: 1,
                      }}
                    >
                      <AccountBalance sx={{ color: 'primary.main' }} />
                      <Typography variant="h6" sx={{ color: 'text.primary' }}>
                        Banka Hesap Bilgileri
                      </Typography>
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: 'left' }}>
                          <Typography
                            variant="body2"
                            sx={{
                              color: 'text.secondary',
                              mb: 0.5,
                              fontWeight: 500,
                            }}
                          >
                            Banka Adı:
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ color: 'text.primary', fontWeight: 500 }}
                          >
                            {bank.name}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: 'left' }}>
                          <Typography
                            variant="body2"
                            sx={{
                              color: 'text.secondary',
                              mb: 0.5,
                              fontWeight: 500,
                            }}
                          >
                            Hesap Sahibi:
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ color: 'text.primary', fontWeight: 500 }}
                          >
                            {bank.owner}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: 'left' }}>
                          <Typography
                            variant="body2"
                            sx={{
                              color: 'text.secondary',
                              mb: 0.5,
                              fontWeight: 500,
                            }}
                          >
                            IBAN:
                          </Typography>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: 'text.primary',
                                fontWeight: 500,
                                fontFamily: 'monospace',
                              }}
                            >
                              {bank.iban}
                            </Typography>
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => handleCopyBankInfo(bank.iban)}
                              sx={{ minWidth: 'auto', p: 0, m: 0 }}
                            >
                              <CopyAll />
                            </Button>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: 'left' }}>
                          <Typography
                            variant="body2"
                            sx={{
                              color: 'text.secondary',
                              mb: 0.5,
                              fontWeight: 500,
                            }}
                          >
                            Açıklama:
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: 'text.primary',
                              fontWeight: 500,
                              fontFamily: 'monospace',
                            }}
                          >
                            Ödeme Referans: {paymentReference}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>

                {/* Ödeme Detayları */}
                <Grid item xs={12} md={4}>
                  <Box
                    sx={{
                      p: 3,
                      pb: 2,
                      borderRadius: 2,
                      fontSize: '0.8rem',
                      backgroundColor: 'action.hover',
                      border: '1px solid',
                      borderColor: 'divider',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2,
                        gap: 1,
                      }}
                    >
                      <Receipt sx={{ color: 'primary.main' }} />
                      <Typography variant="h6" sx={{ color: 'text.primary' }}>
                        Ödeme Detayları
                      </Typography>
                    </Box>

                    <Divider sx={{ mb: 1 }} />

                    {/* Aylık Ücret */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 1,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: 'text.secondary' }}
                      >
                        Aylık:
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: 'text.primary', fontWeight: 500 }}
                      >
                        {currencyFormat(parseFloat(plan.price || '0'))}
                      </Typography>
                    </Box>

                    {/* Adet */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 1,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: 'text.secondary' }}
                      >
                        Adet:
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: 'text.primary', fontWeight: 500 }}
                      >
                        {plan.isYearly ? '12 ay' : '1 ay'}
                      </Typography>
                    </Box>

                    {/* Ara Toplam */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 1,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: 'text.secondary' }}
                      >
                        Ara Toplam:
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: 'text.primary', fontWeight: 500 }}
                      >
                        {currencyFormat(
                          Math.round(
                            parseFloat(plan.price || '0') *
                              (plan.isYearly ? 12 : 1) *
                              100,
                          ) / 100,
                        )}
                      </Typography>
                    </Box>

                    {/* İndirim (Yıllık plan için) */}
                    {plan.isYearly && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mb: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: 'success.main',
                            fontWeight: 500,
                          }}
                        >
                          İndirim (%10):
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: 'success.main', fontWeight: 500 }}
                        >
                          {currencyFormat(
                            Math.round(
                              parseFloat(plan.price || '0') * 12 * 0.1 * 100,
                            ) / 100,
                          )}
                        </Typography>
                      </Box>
                    )}

                    {/* Ödenecek Tutar */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pt: 1,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: 'text.primary' }}
                      >
                        Toplam:
                      </Typography>
                      <Typography
                        variant="body2"
                        fontSize={16}
                        fontWeight={600}
                      >
                        {currencyFormat(
                          plan.isYearly
                            ? Math.round(
                                parseFloat(plan.price || '0') * 12 * 0.9 * 100,
                              ) / 100
                            : parseFloat(plan.price || '0'),
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Fade>

          {/* İpucu */}
          <Fade in={showContent} timeout={1700}>
            <Box
              sx={{
                mb: 3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
              }}
            >
              <Lightbulb sx={{ color: 'warning.main', fontSize: 20 }} />
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  fontSize: '1rem',
                }}
              >
                Ödeme açıklamasına referans numaranızı eklemeyi unutmayın
              </Typography>
            </Box>
          </Fade>
        </Paper>
      </Fade>
    </Box>
  );
};
